// HomeBF.jsx
import React from "react";
import Navbar from "../../../Components/Navbar/Navbar";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ManageProduct from "../Product/ManageProduct";
import ProductDetails from "../Product/ProductDetails";
import AddProduct from "../Product/AddProduct";
import UpdateProduct from "../Product/UpdateProduct";
import ManageEvent from "../Event/ManageEvent";
import AddEvent from "../Event/AddEvent";
import ViewEvent from "../Event/ViewEvent";
import UpdateEvent from "../Event/UpdateEvent";
import ManageFAQ from "../FAQ/ManageFAQ";
import ManageReview from "../Review/ManageReview";
import styles from "./DashboardBF.module.css";

function HomeBF() {
  return (
    <div className={styles.main_container}>
      <Navbar />
      <div className={styles.content_area}>
        <Routes>
          <Route path="manage-product" element={<ManageProduct />} />
          <Route path="product-details/:id" element={<ProductDetails />} />
          <Route path="add-product" element={<AddProduct />} />
          <Route path="update-product" element={<UpdateProduct />} />

          <Route path="manage-event" element={<ManageEvent />} />
          <Route path="add-event" element={<AddEvent />} />
          <Route path="view-event/:eventId" element={<ViewEvent />} />
          <Route path="update-event/:eventId" element={<UpdateEvent />} />

          <Route path="manage-faq" element={<ManageFAQ />} />
          <Route path="manage-review" element={<ManageReview />} />
          <Route index element={<h1>Welcome to BodyFriend CMS</h1>} />
        </Routes>
      </div>
    </div>
  );
}

export default HomeBF;
